import { Link } from "@mui/material";
import type { FC } from "react";
import { useState } from "react";
import { useAuthContext } from "../../auth/AuthContext";
import SendSmsDialog from "../../sms/SendSmsDialog";

interface Props {
  readonly value: string;
}

const Phone: FC<Props> = ({ value }) => {
  const { context } = useAuthContext();
  const [smsDialogOpen, setSmsDialogOpen] = useState(false);

  if (context?.role !== "ADMIN") {
    return (
      <a href={`tel:${value}`} onClick={(e) => e.stopPropagation()}>
        {value}
      </a>
    );
  }
  return (
    <>
      <Link
        component="button"
        type="button"
        variant="inherit"
        sx={{ verticalAlign: "baseline" }}
        onClick={(e) => {
          e.stopPropagation();
          setSmsDialogOpen(true);
        }}
      >
        {value}
      </Link>
      {smsDialogOpen && <SendSmsDialog phoneNumber={value} onClose={() => setSmsDialogOpen(false)} />}
    </>
  );
};

export default Phone;
